"use client";

import { useCallback, useState } from "react";
import { toast } from "sonner";

export function useCopyToClipboard(): { copy: (text: string, label?: string) => Promise<void>; copiedKey: string | null } {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);

  const copy = useCallback(async (text: string, label = "Value") => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedKey(label);
      toast.success(`${label} copied to clipboard`);
      setTimeout(() => setCopiedKey((current) => (current === label ? null : current)), 1500);
    } catch {
      toast.error(`Could not copy ${label.toLowerCase()}`);
    }
  }, []);

  return { copy, copiedKey };
}
